/**
 * Created by anthony on 11/20/14.
 */
applicationsSubNavbar.service('ResetModalService', function($modal){
    var result = {};
    result.initModal = function()
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/applicationsSubNavbar/partials/resetModal.html?v=" + versionNo,
            controller: "ResetModalController"
        });
    }
    return result;
});
